import ClipIcon from "../../assets/paperclip.svg";
import ScrapIcon from "../../assets/scrap.svg";
import GlassesIcon from "../../assets/glasses.svg";
import { FruitType } from "../../context";

interface MessageContent {
	title: string;
	text: string;
}

export interface EForm {
	born?: string;
	age: string;
	hard?: string;
	achivment?: string;
	isAcceptCorret: boolean;
	accept: MessageContent;
	decline?: MessageContent;
}

interface FruitResumeData {
	name: string;
	title: string;
	body: string;
	body2: string;
	instruction: string;
	winners: string[];
	forms: EForm[];
}

type FruitsResumeDataset = {
	[key in FruitType]: FruitResumeData;
};

export const fruitsResumeData: FruitsResumeDataset = {
	mango: {
		name: "мангО",
		title: "фРуктЫ вСтРечают По кОжуРе, а кАндидатоВ — По резЮме",
		body: "Попробуйте оценить манго не только по их внешнему виду, но и по хард-скиллам.",
		body2:
			"Не дайте себя провести — в следующий этап пройдут трое кандидатов. Остальных отправим обратно",
		instruction:
			"Перед вами резюме пяти манго. Жмите «Пропустить» или «Отказать», чтобы оставить троих кандидатов",
		winners: ["1", "2", "4"],
		forms: [
			{
				born: "Египет",
				age: "2 недели",
				hard: "Сладость\nс медовыми нотками",
				isAcceptCorret: true,
				accept: {
					title: "ОтлИчнОе мангО!",
					text: "Сладкое, без пестицидов, а что ещё нужно?",
				},
				decline: {
					title: "Эх... зРЯ Вы так!",
					text: "Это манго было прекрасно от кожуры до тонкой косточки!",
				},
			},
			{
				achivment: "Собрано вручную\nв разгар сезона",
				age: "10 дней",
				hard: "Идеально дозреет,\nпока доберется\nдо полки",
				isAcceptCorret: true,
				accept: {
					title: "Это мАнгО ПоСтаралОсь,\n чтОбы ПопаСть\n вО ВкуСвиЛл!",
					text: "Дадим ему шанс – отправим в комнату дозревания. Пусть набирается опыта, спелости и сочности",
				},
			},
			//  №3
			{
				born: "Швеция",
				age: "45 дней",
				hard: "Характер твёрдый,\nнордический",
				isAcceptCorret: false,
				accept: {
					title: "Ой-оЙ! ТакОе нам Не пОДхОдит",
					text: "Это манго – тот ещё фрукт. Приехало с Севера и в таком нетоварном виде. Испорченные фрукты не попадают во Вкусвилл",
				},
				decline: {
					title: "в ЯбЛОчкО!",
					text: "То есть в манго! Думало, проскочит, но не тут-то было – мы знаем, что манго на Севере не растёт",
				},
			},
			{
				age: "12 дней",
				achivment: "Много мякоти\nи тонкая косточка",
				hard: "Потомок манго,\nкоторое попробовал\nБудда",
				isAcceptCorret: true,
				accept: {
					title: "ОтлИчный ЭкзеМплЯр!",
					text: "Если дойдёт до полки – обязательно проверим, как оно устроилось. Может быть, даже позовём фейхоа и устроим приветственную вечеринку",
				},
				decline: {
					title: "КанДидат показалСя вам\n СлИшкОм утОнчеНнЫМ?",
					text: "А управлению проверки качества это манго понравилось. Если дойдёт до полки – обязательно проверим, как оно устроилось",
				},
			},
			{
				age: "15 дней",
				born: "Исмаилия",
				achivment:
					"Неделю пролежало\nв коробке с пауками,\nно не стало\nарахнофобом",
				isAcceptCorret: false,
				accept: {
					title: "Ой, ЭтОму мангО Не на пОлки, а в машиНу вРеменИ!",
					text: "Его хранили неправильно, ещё и с пауками! Запомним его храбрецом 😬🕷",
				},
				decline: {
					title: "ВернО — манго иЗ Ящика с пауками нам Не поДхОдИт",
					text: "Хотя бесстрашия ему явно не занимать 😬🕷",
				},
			},
		],
	},
	milk: {
		name: "мОлоКО",
		title: "КандИдатоВ вСтРечают пО резЮме",
		body: "Попробуйте оценить молоко не только по внешнему виду, но и по хард-скиллам.",
		body2:
			"Не дайте себя провести — в следующий этап пройдут трое кандидатов. Остальных отправим обратно",
		instruction:
			"Перед вами резюме пяти бутылок молока. Жмите «Пропустить» или «Отказать», чтобы оставить троих кандидатов",
		winners: ["1", "2", "4"],
		forms: [
			{
				born: "Россия",
				age: "3 часа",
				hard: "Обогащено\nвитаминами",
				isAcceptCorret: true,
				accept: {
					title: "хОРоШее мОлоКО!",
					text: "Такое можно и за вредность выдавать",
				},
				decline: {
					title: "ВитАминЫ — Это хОрошО",
					text: "Пропускаем кандидата дальше. Пейте, люди, молоко – будете здоровы!",
				},
			},
			{
				achivment: "Идеальный белый\nцвет — нежный\nи снежный",
				age: "12 часов",
				hard: "Полезно для здоровья\nкостей",
				isAcceptCorret: true,
				accept: {
					title: "ВеРнЫй вЫбОр!",
					text: "Это молоко – серьёзный конкурент для остальных соискателей",
				},
				decline: {
					title: "ПочеМу Нет?",
					text: "Это молоко — серьёзный конкурент для остальных соискателей",
				},
			},
			{
				born: "Австралия",
				age: "Вечность",
				hard: "Собрано от коров\nэлитной породы",
				isAcceptCorret: false,
				accept: {
					title: "Это мОлоКО тОчно не Для ВкусВиЛла",
					text: "Доставки из Австралии идут вечность. Без консервантов и каких-то примесей это молоко точно не пережило бы путешествие",
				},
			},
			{
				age: "10 часов",
				achivment: "Свежее, чем утро\nв Альпах",
				hard: "Идеально\nдля хлопьев\nна завтрак",
				isAcceptCorret: true,
				accept: {
					title: "ОтлИчнЫй кандИдат!",
					text: "Наши комплименты му-шефу! Ой, то есть шеф-повару. Нууу, то есть корове",
				},
				decline: {
					title: "У вас чтО‑то ЛичнОе к альпИйСкОй сВежеСти?",
					text: "На самом деле, это молоко отличное! Дадим ему шанс",
				},
			},
			{
				age: "15 часов",
				achivment: "Не душное – крышка\n закрыта не плотно",
				hard: "Превращается\nв простоквашу",
				isAcceptCorret: false,
				accept: {
					title: "ЭтогО канДидата ТочнО\nНужнО забракоВать!",
					text: "Молоко или прокиснет, или разольётся в дороге. Бутылки должны быть плотно запечатаны",
				},
				decline: {
					title: "Этот канДидат\nнам Не пОДхОдит",
					text: "Бутылки с молоком должны быть плотно запечатаны. Жаль – упаковка с дыркой выглядела авангардно",
				},
			},
		],
	},
	roll: {
		name: "РОлЛ",
		title: "КандИдатоВ вСтРечают пО резЮме",
		body: "Попробуйте оценить роллы с форелью не только по их внешнему виду, но и по хард-скиллам.",
		body2:
			"Не дайте себя провести — в следующий этап пройдут трое кандидатов. Остальных отправим обратно",
		instruction:
			"Перед вами пять резюме роллов с форелью. Жмите «Пропустить» или «Отказать», чтобы оставить троих кандидатов",
		winners: ["1", "3", "5"],
		forms: [
			{
				born: "Норвегия",
				age: "1 час",
				hard: "Отлично подходит\nдля перекуса",
				isAcceptCorret: true,
				accept: {
					title: "пРавИльнЫй вЫбОр!",
					text: "Не кандидат – а просто палочки оближешь",
				},
				decline: {
					title: "ЗачеМ рАзВеРнулИ так КрасивО ЗавеРнутОе?",
					text: "К кандидату нет вопросов, и покупателям нравится – пропускаем этот ролл дальше",
				},
			},
			{
				born: "Беларусь",
				age: "7 дней",
				achivment: "Много майонеза —\nс ним всё вкуснее",
				isAcceptCorret: false,
				accept: {
					title: "Ах, ЗнаМенитЫе дарЫ МинСкОго мОрЯ!",
					text: "Такой ролл нам не подходит. Пахнет картошкой, ещё и с майонезом! Кулинария во ВкусВилле правильная и полезная",
				},
				decline: {
					title: "Ах, ЗнаМенитЫе дарЫ МинСкОго мОрЯ!",
					text: "Куда столько майонеза? Кулинария во ВкусВилле правильная и полезная",
				},
			},
			{
				achivment: "Идеально\nсваренный рис",
				age: "4 часа",
				hard: "Аппетитный,\nпитательный, свежий",
				isAcceptCorret: true,
				accept: {
					title: "ПраВильнЫй вЫбоР!",
					text: "Этот ролл настолько прекрасен, что смог бы победить на конкурсе кроллсоты и талантов",
				},
				decline: {
					title: "Увы, Не мОЖем сОгласИтьсЯ!",
					text: "Этот ролл настолько прекрасен, что смог бы победить на конкурсе кроллсоты и талантов",
				},
			},
			{
				achivment: "Срок годности\nбольше благодаря\nмороженой форели",
				age: "15 часов",
				hard: "Начинки так много,\nчто вываливается",
				isAcceptCorret: false,
				accept: {
					title: "Нет, таК не пОйДёт",
					text: "Ролл плохо скручен, а рыба замороженная и просится обратно в зимнюю лужу",
				},
				decline: {
					title: "ВернО!",
					text: "Этот кандидат не для ВкусВилла – он плохо скручен, ещё и рыба замороженная",
				},
			},
			{
				born: "Дальний\nВосток",
				age: "10 часов",
				hard: "Бесподобно вкусный\nдаже без соевого\nсоуса и имбиря",
				isAcceptCorret: true,
				accept: {
					title: "Нам тОже пОнравилСЯ этОт рОлЛ!",
					text: "Он мог бы стать даже суши, если бы захотел",
				},
				decline: {
					title: "РОлЛ ПрОходИт ДальШе!",
					text: "Он прилетел с Дальнего Востока, дадим ему отдохнуть и пропустим в следующий этап",
				},
			},
		],
	},
};

export const fruitsIcon = [
	{
		icon: ClipIcon,
		iconPos: "-bottom-2 left-2.5 short:bottom-2",
	},
	{
		icon: "",
		iconPos: "-bottom-[40px] left-[10px] short:-bottom-14",
		img: "/images/interview/pen.webp",
	},
	{
		icon: ScrapIcon,
		iconPos: "-bottom-2 left-2.5",
	},
	{
		icon: GlassesIcon,
		iconPos: "-bottom-10 -left-10 short:-bottom-0 short:left-0",
	},
	{
		icon: ClipIcon,
		iconPos: "-bottom-5 left-2.5 short:-bottom-2",
	},
];
